import type { ComponentProps } from 'react'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'

/*
 * Boxes for what staff write fresh to send or record with one action: a message or email (its
 * recipients, subject and body), a chat reply, a note, a reason. Plain text boxes are deprecated
 * (USA-1580); composing is one of the named places a box is still the right control. A saved value
 * is edited with POInlineEditableField or InlineFieldGroup, never with these.
 *
 * `bare` drops the shared box styling for a composer that draws its own shell.
 */

export function ComposeInput(props: ComponentProps<'input'>) {
  return <Input {...props} />
}

export function ComposeTextarea({ bare = false, ...props }: ComponentProps<'textarea'> & { bare?: boolean }) {
  return bare ? <textarea {...props} /> : <Textarea {...props} />
}
